import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import cancelPolicyPagesRoleManagement, {
  ADD_ON_POLICIES_ROUTE,
  POLICIES_ROUTE
} from '../../staticRoleManagement/cancelPolicyRoleManagement'
import AddOnPoliciesList from '../AddOnPoliciesList'
import CancelPoliciesList from '../CancelPoliciesList'
import ModifyPoliciesList from '../ModifyPoliciesList'
import useStyles from './styles/index.styles'

export default function PoliciesTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()

  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      value: 'cancel-policies',
      className: classes.tab,
      label: getTranslate('Cancel Policies'),
      component: LocalizedLink,
      to: '/policies/cancel-policies'
    },
    {
      value: 'amendment-policies',
      className: classes.tab,
      label: getTranslate('Amendment Policies'),
      component: LocalizedLink,
      to: '/policies/amendment-policies'
    },
    {
      value: 'add-on-policies',
      className: classes.tab,
      label: getTranslate('Add-On Policies'),
      component: LocalizedLink,
      to: '/policies/add-on-policies'
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  // The add-on tab is declared on its own route (see cancelPolicyRoleManagement), so each tab
  // is checked against the route that declares it.
  const routeConfigFor = (tab: string) =>
    cancelPolicyPagesRoleManagement.find(
      (item) =>
        item.route ===
        (tab === 'add-on-policies' ? ADD_ON_POLICIES_ROUTE : POLICIES_ROUTE)
    )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfigFor(tab.value), tab.value, featureSet)
  )

  if (!canAccessTab(routeConfigFor(page), page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((tabItem) => (
            <Tab
              key={tabItem.value}
              value={tabItem.value}
              className={tabItem.className}
              label={tabItem.label}
              to={tabItem.to}
              component={LocalizedLink}
            />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="cancel-policies"
        dir={theme.direction}
        className={classes.tabPanel}>
        <CancelPoliciesList />
      </TabPanel>
      <TabPanel
        value={page}
        index="amendment-policies"
        dir={theme.direction}
        className={classes.tabPanel}>
        <ModifyPoliciesList />
      </TabPanel>
      <TabPanel
        value={page}
        index="add-on-policies"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AddOnPoliciesList />
      </TabPanel>
    </div>
  )
}
